module.exports = __webpack_public_path__ + "static/media/icon_openLink.d158ef51.svg";